import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { ComponentPropsWithoutRef, ComponentType } from "react";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

interface CreateCompassModalSwitcherOptions {
  removeOnClose?: boolean;
}

export function createCompassModalSwitcher<
  TCompass extends ComponentType<any>,
  TUIKit extends ComponentType<any>,
>(
  CompassComponent: TCompass,
  UIKitComponent: TUIKit,
  { removeOnClose = false }: CreateCompassModalSwitcherOptions = {},
) {
  type ExternalProps = Omit<
    ComponentPropsWithoutRef<TCompass>,
    "open" | "onOpenChange"
  >;

  const UIKitModal = ModalManager.create((props: ExternalProps) => (
    <UIKitComponent {...(props as any)} />
  ));

  const CompassModal = ModalManager.create((props: ExternalProps) => {
    const modal = useModal();

    return (
      <CompassComponent
        {...(props as any)}
        open={modal.visible}
        onOpenChange={(open: boolean) => {
          if (!open) {
            if (removeOnClose) {
              modal.remove();
            } else {
              void modal.hide();
            }
          }
        }}
      />
    );
  });

  return () => {
    const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");
    return useModal(isCircleV4 ? CompassModal : UIKitModal);
  };
}
